import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import cn from 'classnames';
import { Grid, GridItem, TextButton, Typography, useOverlayContext } from 'seagull';
import { SwitchProposalBusiness } from '~/client-flow/clientOb/WelcomeStep/SwitchProposalBusiness/SwitchProposalBusiness';
import { filterCustomerWorkspaces } from '~/client-flow/clientOb/WelcomeStep/welcomeStepUtils';
import { routes } from '~/constants';
import { useOnMount } from '~/hooks/useOnMount';
import { useSwitchBusiness } from '~/hooks/useSwitchBusiness';
import { selectors } from '~/store/state-selectors';
import { useStore, useStoreActions } from '~/store/store-context';
import { useResponsive } from '../../contexts';
import styles from './AgreementHeader.module.scss';
function getFullName(name) {
    return !name.firstName ? null : !name.lastName ? name.firstName : name.firstName + ' ' + name.lastName;
}
export function AgreementHeader(param) {
    let { relationship, companyName, className, isPreview } = param;
    const { isMobile } = useResponsive();
    const { logBI } = useStoreActions();
    const email = useStore((state)=>{
        var _state_userInfo;
        return (_state_userInfo = state.userInfo) === null || _state_userInfo === void 0 ? void 0 : _state_userInfo.email();
    });
    const workspaces = useStore(selectors.user.workspaces);
    const overlayContext = useOverlayContext();
    const [showSwitchProposalBusiness, setShowSwitchProposalBusiness] = useState(false);
    const { switchBusiness } = useSwitchBusiness();
    useOnMount(()=>{
        if (!isPreview && !relationship.isSample && workspaces) {
            setShowSwitchProposalBusiness(filterCustomerWorkspaces(workspaces, relationship.vendor.id).length > 1);
        }
    });
    const onSwitchProposalBusiness = async ()=>{
        logBI(10834, {
            companyName,
            email
        });
        const newBusinessId = await overlayContext.showModal({
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(SwitchProposalBusiness, {
                    onClose: dismissModal,
                    relationship: relationship
                });
            }
        });
        if (newBusinessId) {
            await switchBusiness(newBusinessId, {
                newRoute: routes.clientOnboarding(relationship.id)
            });
        }
    };
    return /*#__PURE__*/ _jsxs(Grid, {
        rowGap: 'small',
        className: className,
        children: [
            /*#__PURE__*/ _jsx(GridItem, {
                span: 12,
                children: /*#__PURE__*/ _jsx(Typography, {
                    children: "Agreement between"
                })
            }),
            /*#__PURE__*/ _jsxs(GridItem, {
                span: isMobile ? 12 : 6,
                className: cn(styles.side, {
                    [styles.mobile]: isMobile
                }),
                children: [
                    relationship.seller.firstName && /*#__PURE__*/ _jsx(Typography, {
                        skin: "secondary",
                        variant: "paragraph1",
                        weight: "normal",
                        testId: "agreement-header-vendor-name",
                        children: getFullName(relationship.seller)
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        skin: "secondary",
                        variant: "paragraph1",
                        testId: "agreement-header-vendor-business",
                        children: relationship.vendor.name
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        skin: "secondary",
                        variant: "paragraph1",
                        children: relationship.seller.email
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(GridItem, {
                span: isMobile ? 12 : 6,
                className: cn(styles.side, {
                    [styles.mobile]: isMobile
                }),
                children: [
                    relationship.buyer.firstName && /*#__PURE__*/ _jsx(Typography, {
                        skin: "secondary",
                        variant: "paragraph1",
                        weight: "normal",
                        testId: "agreement-header-client-name",
                        children: getFullName(relationship.buyer)
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        skin: "secondary",
                        variant: "paragraph1",
                        testId: "agreement-header-client-business",
                        children: companyName
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        skin: "secondary",
                        variant: "paragraph1",
                        children: relationship.buyer.email
                    }),
                    showSwitchProposalBusiness && /*#__PURE__*/ _jsx(TextButton, {
                        testId: "switch-proposal-business",
                        onClick: onSwitchProposalBusiness,
                        children: "Assign to a different business"
                    })
                ]
            })
        ]
    });
}
